import { createFileRoute, Navigate } from '@tanstack/react-router';

// Bare /app/item/new → default to composing a memo. Lives in the index route
// (not the layout) so it doesn't swallow the /$type composer child.
export const Route = createFileRoute('/_authed/app/item/new/')({
  component: () => <Navigate to="/app/item/new/$type" params={{ type: 'memo' }} replace />,
});
